<template>
  <my-card shadow="never">
    <div slot="header">
      <div style="display: flex; justify-content: space-between">
        <span class="title">分析列表</span>
        <div style="display: flex; align-items: center">
          <icon
            style="width: 16px; height: 16px; margin-right: 10px"
            name="download"
            @click="handleExportTableData"
          ></icon>

          <div>
            <t-switch size="large" v-model="tableShowType" @change="handleChangeTableShowType"></t-switch>
            <span style="margin-left: 10px">{{ tableShowType ? '展开日期' : '收起日期' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="" v-if="loading || tableList.length >= 0">
      <el-table
        ref="multipleTable"
        :data="tableList"
        header-row-class-name="analysis-table-header"
        :row-class-name="handleTableRowClassName"
        :cell-class-name="handleTableCellClassName"
        :span-method="handleTableSpanMethod"
        v-loading="loading"
        tooltip-effect="dark"
        style="width: 100%"
        border
        align="right"
      >
        <template v-for="col in tableColumns">
          <el-table-column
            :label="col.label"
            :prop="col.field"
            :key="col.key"
            header-align="right"
            :show-overflow-tooltip="true"
            :width="col.width"
            :align="col.align || 'center'"
          >
            <template #header>
              <div v-if="col.type === 'target'" class="flex-row">
                <!--<span class="zhibiao-idx">{{ col.zhibiaoIdxChar }}</span>-->
                <span>{{ col.label }}</span>
              </div>
              <div v-else>{{ col.label }}</div>
            </template>
            <template slot-scope="scope">
              <div v-if="col.type === 'collapse'" @click="handleToggleCollapse(scope.row, col)" class="collapse">
                <icon name="caret-down-small" size="20px" v-if="!!scope.row.collapsed" />
                <icon name="caret-up-small" size="20px" v-if="!scope.row.collapsed" />
              </div>
              <sub-table
                v-else-if="col.lastWeidu && !scope.row.collapsed"
                :show-compare-date="showCompareDate"
                :unit="unit"
                :zhibiao-list="zhibiaoList"
                :shuxing-weidu-list="shuxingWeiduList"
                :last-get-data-params="lastGetDataParams"
                :last-get-data-params-compare="lastGetDataParamsCompare"
                :group-data-obj-list="groupDataObjList"
                :group-data-obj-list-compare="groupDataObjListCompare"
                :row="scope.row"
                :col="col"
                :can-export-num-cols="canExportNumCols"
                :date-keys="dateKeys"
              ></sub-table>
              <table-cell-value
                v-else
                :row="scope.row"
                :col="col"
                :col-name="col.field"
                :show-compare-date="showCompareDate"
                :can-export-num-cols="canExportNumCols"
                :last-get-data-params="lastGetDataParams"
                :last-get-data-params-compare="lastGetDataParamsCompare"
                @submitSaveCrowd="handleSubmitSaveCrowd"
              ></table-cell-value>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div class="footer">
        <t-pagination
          v-model="paginationData.page"
          :total="paginationData.total"
          :page-size.sync="paginationData.pageSize"
          @current-change="handlePageChange"
          @page-size-change="handlePageSizeChange"
        />
      </div>
    </div>
    <no-data v-else></no-data>
  </my-card>
</template>
<script>
import XLSX from 'xlsx';
import dayjs from 'dayjs';
import { getCharFromInt } from '@/utils/common';
import noData from '@/components/common/no-data-card.vue';
import { savePackageEvent } from '@/api/analysis/custom-analysis';
import SubTable from './event-analysis-table-transform-subtable.vue';
import TableCellValue from '@/views/analysis/event-analysis/components/table-cell-value.vue';
// import NumPopver from './num-popover';
import { extractMetaConfig, fillValArr, getWeiduNameDesc, getWeiduValueDesc, replenishDateVal } from '@/utils/helper';

export default {
  components: {
    noData,
    SubTable,
    // NumPopver,
    TableCellValue,
  },
  props: {
    changeTrigger: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    unit: {
      type: String,
      default: 'day',
    },
    dateKeys: {
      type: Object, // {baseDateKeys: [], compareDateKeys: []}
    },
    showCompareDate: {
      type: Boolean,
    },
    zhibiaoList: {
      type: Array,
    },
    conditionOperatorOptions: {
      type: Array,
      default: () => [],
    },
    shuxingWeiduOptions: {
      type: Array,
      default: () => [],
    },
    shuxingWeiduList: {
      type: Array,
      default: () => [],
    },
    lastGetDataParams: {
      // 最后一次成功请求数据的参数。因为用户可以随时更改页面上的配置，而不实际请求数据
      type: Object,
    },
    lastGetDataParamsCompare: {
      type: Object,
    },
    groupDataObjList: {
      type: Object,
    },
    groupDataObjListCompare: {
      type: Object,
    },
  },
  data() {
    return {
      oriTableList: [],
      canExportNumCols: [],

      tableStatType: 'valSum',
      tableShowType: false,
      paginationData: {
        total: 0,
        page: 1,
        pageSize: 20,
      },
    };
  },
  watch: {
    shuxingWeiduList() {
      this.makeTableList();
    },
    groupDataObjList() {
      this.makeTableList();
    },
    // groupDataObjListCompare() {
    //   this.makeTableList();
    // },
  },
  computed: {
    weiduList() {
      const { allWeiduList } = extractMetaConfig(this.lastGetDataParams);
      return allWeiduList;
    },
    tableColumns() {
      const columns = [];
      const { zhibiaoList, allWeiduList } = extractMetaConfig(this.lastGetDataParams);
      if (allWeiduList.length === 0) {
        columns.push({
          label: '日期',
          field: 'date',
          key: 'date',
        });
      } else {
        columns.push({
          label: '',
          field: '',
          type: 'collapse',
          key: 'collapse',
          width: 60,
        });
        const wdLen = allWeiduList.length;
        allWeiduList.forEach((witem, i) => {
          columns.push({
            label: getWeiduNameDesc(this.shuxingWeiduOptions, witem),
            field: witem.val,
            key: witem.val,
            type: 'weidu',
            lastWeidu: i === wdLen - 1,
          });
        });
      }

      zhibiaoList.forEach((zhibiaoItem, idx) => {
        columns.push({
          label: zhibiaoItem.zhibiaoTitle,
          field: `target_name_${idx}`,
          key: `target_name_${idx}_${zhibiaoItem.zhibiaoTitle}`,
          type: 'target',
          zhibiaoIdx: idx,
          zhibiaoIdxChar: getCharFromInt(idx),
          align: 'right',
        });
      });

      return columns;
    },
    tableList() {
      const start = (this.paginationData.page - 1) * this.paginationData.pageSize;
      const end = start + this.paginationData.pageSize;

      return this.oriTableList.slice(start, end);
    },
  },

  mounted() {
    // this.paginationData.total = this.oriTableList.length;
    // this.paginationData.page = this.pagerData.page;
    // this.paginationData.pageSize = this.pagerData.pageSize;
    this.makeTableList();
  },

  methods: {
    resetData() {
      this.oriTableList = [];
      this.canExportNumCols = [];
      this.paginationData.total = 0;
      this.paginationData.page = 1;
    },

    makeTableList() {
      this.resetData();
      const { unit } = this;
      const tableList = [];
      const canExportNumCols = [];

      const { zhibiaoList, allWeiduList } = extractMetaConfig(this.lastGetDataParams);

      zhibiaoList.forEach((zhibiaoItem, idx) => {
        if (zhibiaoItem.eventList.length === 1 && zhibiaoItem.eventList[0].eventTargetColumn.type === 'totalPeople') {
          canExportNumCols.push(`target_name_${idx}`);
        }
      });

      const { baseDateKeys, compareDateKeys } = this.dateKeys;

      const { list, dates } = replenishDateVal(this.groupDataObjList, baseDateKeys);
      let compareList = [];
      let compareDates = [];
      if (this.showCompareDate) {
        const compareData = replenishDateVal(this.groupDataObjListCompare, compareDateKeys);
        compareList = compareData.list;
        compareDates = compareData.dates;
      }

      if (allWeiduList.length === 0) {
        // 没有维度的情况
        dates.forEach((date, dateIdx) => {
          let compareDate;
          if (this.showCompareDate) {
            compareDate = compareDates[dateIdx];
          }
          const tmpObj = {
            isDateRow: true,
            canRowExportCrowd: !!canExportNumCols.length,
            date: this.showCompareDate
              ? [
                  dayjs(date).format(unit === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'),
                  dayjs(compareDate).format(unit === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'),
                ]
              : [dayjs(date).format(unit === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')],
          };

          list.forEach(item => {
            const valArr = [item.dateValues[dateIdx]];

            if (this.showCompareDate) {
              const compareItem = compareList.find(i => i.target_name === item.target_name);
              if (compareItem) {
                valArr.push(compareItem.dateValues[dateIdx]);
              }
            }
            const zhibiaoIdx = zhibiaoList.findIndex(zhibiao => zhibiao.zhibiaoTitle === item.target_name);
            tmpObj[`target_name_${zhibiaoIdx}`] = fillValArr(valArr, this.showCompareDate);
          });
          tableList.push(tmpObj);
        });
        // 后面追加一个合计
        const sumObj = {
          canRowExportCrowd: !!canExportNumCols.length,
          date: '总体',
        };
        zhibiaoList.forEach((zhibiaoItem, idx) => {
          const valArr = [];
          const findItem = list.find(item => item.target_name === zhibiaoItem.zhibiaoTitle);
          valArr.push(findItem ? findItem.valueSum : '-');
          if (this.showCompareDate) {
            const findItemCompare = compareList.find(item => item.target_name === zhibiaoItem.zhibiaoTitle);
            valArr.push(findItemCompare ? findItemCompare.valueSum : '-');
          }
          sumObj[`target_name_${idx}`] = fillValArr(valArr, this.showCompareDate);
        });
        tableList.push(sumObj);
      } else {
        // 有维度的情况
        list.forEach(item => {
          // allWeiduList.forEach(wd => {
          //   item[wd.val] = getWeiduValueDesc(this.lastGetDataParams, wd, item);
          // });
        });
        compareList.forEach(item => {
          // allWeiduList.forEach(wd => {
          //   item[wd.val] = getWeiduValueDesc(this.lastGetDataParamsCompare, wd, item);
          // });
        });
        list.forEach(item => {
          let sumObj = tableList.find(row => allWeiduList.every(wd => row[wd.val] === item[wd.val]));
          if (!sumObj) {
            sumObj = {
              collapsed: true,
              canRowExportCrowd: !!canExportNumCols.length,
              ...item,
            };
            delete sumObj.dateValues;
            delete sumObj.valueSum;
            delete sumObj.valueAvg;
            delete sumObj.target_name;
            tableList.push(sumObj);
          }

          const zhibiaoIdx = zhibiaoList.findIndex(zhibiaoItem => zhibiaoItem.zhibiaoTitle === item.target_name);
          const valArr = [item.valueSum === null ? '-' : item.valueSum];

          let compareItem;
          if (this.showCompareDate) {
            compareItem = compareList.find(
              subItem =>
                allWeiduList.every(wd => item[wd.val] === subItem[wd.val]) && item.target_name === subItem.target_name,
            );
            valArr.push(compareItem && compareItem.valueSum !== null ? compareItem.valueSum : '-');
          }

          sumObj[`target_name_${zhibiaoIdx}`] = fillValArr(valArr, this.showCompareDate);
        });
      }

      this.oriTableList = tableList;
      this.paginationData.total = tableList.length;
      this.canExportNumCols = canExportNumCols;
    },

    async handleSubmitSaveCrowd({ row, col, idx = 0 }, { name, desc }, callback) {
      let val = row[col.field];
      if (Array.isArray(val)) {
        val = val[idx];
      }
      if (val > 1000000) {
        this.toast('人群数超100万，暂不支持提取', 'warning');
        return;
      }

      const latitude = {};
      const reqParams = {
        eventInfo: idx === 0 ? this.lastGetDataParams : this.lastGetDataParamsCompare,
        packageName: name,
        packageDesc: desc,
        eventPosition: col.zhibiaoIdx,
        latitude,
      };
      const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all').map(i => i.val);
      weiduList.forEach(w => {
        latitude[w] = row[w];
      });
      if (row.isDateRow) {
        latitude.import_date = row.date[idx];
      }
      try {
        const packageId = await savePackageEvent({ data: reqParams });
        // eslint-disable-next-line no-unused-expressions
        callback && callback(packageId);
      } finally {
        // nothing
      }
    },

    handleChangeTableStatType() {
      this.$emit('onChangeStatType', this.tableStatType);
    },

    checkCanExportCrowd(row, col, idx = 0) {
      let colName = col.field;
      if (col.type === 'stat') {
        colName = this.tableStatType;
      }
      let val = row[colName];
      if (Array.isArray(val)) {
        val = val[idx];
      }
      return this.canExportNumCols.includes(colName) && !!row.canRowExportCrowd && val > 0;
    },

    handlePageSizeChange(pageSize) {
      this.paginationData.pageSize = pageSize;
    },

    handlePageChange(page) {
      this.paginationData.page = page;
    },

    handleTableRowClassName({ row }) {
      const classArr = [];
      if (row.canRowExportCrowd) {
        classArr.push('export-people-row');
      }
      if (!row.collapsed) {
        classArr.push('has-sub-table');
      }
      return classArr.join(' ');
    },

    handleTableCellClassName({ row, columnIndex }) {
      const col = this.tableColumns[columnIndex];
      if (col.type === 'collapse') {
        return 'collapse';
      }
      if (!row.collapsed && col.lastWeidu) {
        return 'subTable';
      }
      return '';
    },

    // eslint-disable-next-line no-unused-vars
    handleTableSpanMethod({ row, column, rowIndex, columnIndex }) {
      const col = this.tableColumns[columnIndex];
      if (this.weiduList.length && !row.collapsed) {
        // 展开状态
        if (col.type === 'target') {
          return {
            rowspan: 1,
            colspan: 0,
          };
        }
        if (col.lastWeidu) {
          return {
            rowspan: 1,
            colspan: this.zhibiaoList.length + 1,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },

    handleToggleCollapse(row) {
      row.collapsed = !row.collapsed;
      console.log(this.tableList);
    },

    handleChangeTableShowType(v) {
      this.$emit('onChangeTableShowType', v ? 'row' : 'col');
    },

    handleExportTableData() {
      const cols = JSON.parse(JSON.stringify(this.tableColumns));
      const { tableStatType } = this;
      // const fileName = `腾讯有数-事件分析结果-${dayjs().format('YYYY-MM-DD')}.xlsx`;
      const fileName = '分析结果.xlsx';
      const data = [];
      // eslint-disable-next-line array-callback-return
      data.push(
        cols.map(col => {
          if (col.type === 'stat') {
            return tableStatType === 'valSum' ? '合计' : '均值';
          }
          return col.label;
        }),
      );
      function formatValue(v) {
        if (v === undefined) {
          return '';
        }
        if (Array.isArray(v) && v.length > 1) {
          // 数量大于1，才用join，这样生成的是字符串，在excel不能参与数字计算
          return v.join('/');
        }
        return v;
      }
      this.oriTableList.forEach(item => {
        const tmpArr = [];
        cols.forEach(col => {
          let val;
          if (col.type === 'stat') {
            val = item[tableStatType];
          } else {
            val = item[col.field];
          }
          tmpArr.push(formatValue(val));
        });
        data.push(tmpArr);
      });
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '事件分析数据');
      XLSX.writeFile(workbook, fileName);
    },
  },
  filters: {
    formatNum(v) {
      return v !== null && v !== undefined ? v.toLocaleString() : '-';
    },
  },
};
</script>
<style lang="less" scoped>
.collapse {
  cursor: pointer;
  i {
    font-size: 24px;
  }
}
</style>
